var module = angular.module('octopusApp.projects');

module.run(function(pluginRegistry, actionExecutionLocations) {
    pluginRegistry.registerDeploymentAction("Octopus.WindowsService", function(busy, octopusRepository) {
        return {
            executionLocation: actionExecutionLocations.alwaysOnTarget,
            canChooseRoles: true,
            canHaveChildren: function() { return true; },
            canBeChild: true,
            hasPackages: function(action) { return true; },
            features: {
                permanent: ["Octopus.Features.WindowsService"],
                optional: ["Octopus.Features.ConfigurationTransforms", "Octopus.Features.ConfigurationVariables", "Octopus.Features.CustomDirectory",
                    "Octopus.Features.CustomScripts", "Octopus.Features.JsonConfigurationVariables", "Octopus.Features.SubstituteInFiles"],
                initial: ["Octopus.Features.ConfigurationTransforms","Octopus.Features.ConfigurationVariables"]
            },

            summaryTemplateUrl: "areas/projects/actions/Octopus.WindowsService_summary.html",

            editTemplateUrl: "areas/projects/actions/Octopus.TentaclePackage_edit.html",
            
            summaryLink: function($scope, element) {
                return octopusRepository.Feeds.get($scope.properties["Octopus.Action.Package.FeedId"]).then(function(feed){
                    $scope.feedName = feed.Name;
                });
            }
        };
    });
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/actions/Octopus.WindowsService.js
// module id = 8738779027933406
// module chunks = 1